import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { App } from "@app";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || "development",
    sendDefaultPii: true
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Сигнал для пререндера: снимок HTML делается только после того, как Helmet
// проставил мета-теги. Ждём фактического появления canonical, а не фиксированной паузы.
const signalPrerenderReady = (attempt = 0): void => {
  const helmetApplied = document.head.querySelector(
    'link[rel="canonical"][data-rh], meta[name="description"][data-rh]'
  );

  if (helmetApplied || attempt > 60) {
    document.dispatchEvent(new Event("prerender-ready"));
    return;
  }

  setTimeout(() => signalPrerenderReady(attempt + 1), 100);
};

requestAnimationFrame(() => signalPrerenderReady());
